'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hashToUserQueryId = exports.createAnalytics = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _dtm = require('./adapters/dtm');

var _dtm2 = _interopRequireDefault(_dtm);

var _tealium = require('./adapters/tealium');

var _tealium2 = _interopRequireDefault(_tealium);

var _createStore = require('./createStore');

var _createStore2 = _interopRequireDefault(_createStore);

var _evaluateSearchType = require('./utils/evaluateSearchType');

var _hashToUserQueryId = require('./utils/hashToUserQueryId');

var _hashToUserQueryId2 = _interopRequireDefault(_hashToUserQueryId);

var _evaluateLinkType = require('./utils/evaluateLinkType');

var _evaluateLinkType2 = _interopRequireDefault(_evaluateLinkType);

var _evaluateLotameValues = require('./utils/evaluateLotameValues');

var _evaluateLotameValues2 = _interopRequireDefault(_evaluateLotameValues);

var _mapNullToBlank = require('./utils/mapNullToBlank');

var _mapNullToBlank2 = _interopRequireDefault(_mapNullToBlank);

var _getExperimentLinkName = require('./utils/getExperimentLinkName');

var _getExperimentLinkName2 = _interopRequireDefault(_getExperimentLinkName);

var _evaluateLmisEvent = require('./utils/evaluateLmisEvent');

var _evaluateLmisEvent2 = _interopRequireDefault(_evaluateLmisEvent);

var _search = require('./reducers/search');

var _search2 = _interopRequireDefault(_search);

var _location = require('./reducers/location');

var _location2 = _interopRequireDefault(_location);

var _user = require('./reducers/user');

var _user2 = _interopRequireDefault(_user);

var _home = require('./reducers/home');

var _home2 = _interopRequireDefault(_home);

var _link = require('./reducers/link');

var _link2 = _interopRequireDefault(_link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createAnalytics = function createAnalytics() {
  var initialState = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
  var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
  var environment = options.environment;


  var store = (0, _createStore2.default)(initialState);
  var update = store.update;
  var getState = store.getState;


  var dtm = (0, _dtm2.default)({
    account: 'e17a3938778a91572e4dadec759bef252bf332ce/satelliteLib-b161516d8872a29e614c73f12d71ac81319df025',
    environment: environment === 'production' ? '' : '-staging'
  });

  var tealium = (0, _tealium2.default)({
    account: 'seek/houston',
    environment: environment === 'production' ? 'prod' : 'dev'
  });

  var searchPerformed = function searchPerformed(props) {
    return update((0, _search2.default)(getState(), props));
  };

  var moreOptionsClicked = function moreOptionsClicked() {
    return update((0, _search.searchTypeOverride)(getState(), _evaluateSearchType.MORE_OPTIONS));
  };

  var didYouMeanClicked = function didYouMeanClicked() {
    return update((0, _search.searchTypeOverride)(getState(), _evaluateSearchType.DID_YOU_MEAN));
  };

  var lastSearchClicked = function lastSearchClicked() {
    return update((0, _search.searchTypeOverride)(getState(), _evaluateSearchType.LAST_SEARCH));
  };

  var quickSearchClassificationClicked = function quickSearchClassificationClicked() {
    return update((0, _search.searchTypeOverride)(getState(), _evaluateSearchType.QUICK_SEARCH_CLASSIFICATION));
  };

  var quickSearchCityClicked = function quickSearchCityClicked() {
    return update((0, _search.searchTypeOverride)(getState(), _evaluateSearchType.QUICK_SEARCH_CITY));
  };

  var quickSearchGraduateClicked = function quickSearchGraduateClicked() {
    return update((0, _search.searchTypeOverride)(getState(), _evaluateSearchType.QUICK_SEARCH_GRADUATE));
  };

  var jobClassificationClicked = function jobClassificationClicked() {
    return update((0, _search.searchTypeOverride)(getState(), _evaluateSearchType.JOB_CLASSIFICATION));
  };

  var jobSubclassificationClicked = function jobSubclassificationClicked() {
    return update((0, _search.searchTypeOverride)(getState(), _evaluateSearchType.JOB_SUBCLASSIFICATION));
  };

  var jobLocationClicked = function jobLocationClicked() {
    return update((0, _search.searchTypeOverride)(getState(), _evaluateSearchType.JOB_LOCATION));
  };

  var jobAreaClicked = function jobAreaClicked() {
    return update((0, _search.searchTypeOverride)(getState(), _evaluateSearchType.JOB_AREA));
  };

  var jobSuburbClicked = function jobSuburbClicked() {
    return update((0, _search.searchTypeOverride)(getState(), _evaluateSearchType.JOB_SUBURB));
  };

  var savedSearchClicked = function savedSearchClicked() {
    return update((0, _search.searchTypeOverride)(getState(), _evaluateSearchType.SAVED_SEARCH));
  };

  var sortModeChanged = function sortModeChanged() {
    return update((0, _search.searchBySortModeChange)(getState(), true));
  };

  var userDetailsUpdated = function userDetailsUpdated(props) {
    return update((0, _user2.default)(getState(), props));
  };

  var locationChanged = function locationChanged(props) {
    return update((0, _location2.default)(getState(), props));
  };

  var whereFieldBlanked = function whereFieldBlanked() {
    return update((0, _search.searchAutosuggests)(getState(), 'where_blank'));
  };
  var whereFieldTyped = function whereFieldTyped() {
    return update((0, _search.searchAutosuggests)(getState(), 'where_typed'));
  };
  var whereFieldRecentSelected = function whereFieldRecentSelected() {
    return update((0, _search.searchAutosuggests)(getState(), 'where_recent'));
  };
  var whereFieldSuggestedSelected = function whereFieldSuggestedSelected() {
    return update((0, _search.searchAutosuggests)(getState(), 'where_suggested'));
  };
  var whereFieldAutosuggestedSelected = function whereFieldAutosuggestedSelected() {
    return update((0, _search.searchAutosuggests)(getState(), 'where_autosuggested'));
  };

  var whereFieldFocused = function whereFieldFocused() {
    dtm.track('where-field-focused', getState());
  };

  var whereFieldRecentShown = function whereFieldRecentShown() {
    dtm.track('where-field-recent-shown', getState());
  };

  var whereFieldSuggestedShown = function whereFieldSuggestedShown() {
    dtm.track('where-field-suggested-shown', getState());
  };

  var homePageLoaded = function homePageLoaded() {
    update((0, _home2.default)(getState()));
    dtm.track('home', getState());
    tealium.view('home', (0, _evaluateLotameValues2.default)(getState()));
  };

  var searchResultsPageLoaded = function searchResultsPageLoaded() {
    dtm.track('job-search', (0, _mapNullToBlank2.default)(getState(), function (key) {
      return key !== 'searchEvents';
    }));
    tealium.view('job-search', (0, _evaluateLotameValues2.default)(getState()));
  };

  var createSaveSearchClicked = function createSaveSearchClicked() {
    dtm.track('save-search', getState());
    tealium.link('save-search');
  };

  var createJobMailClicked = function createJobMailClicked() {
    dtm.track('job-mail', getState());
    tealium.link('job-mail');
  };

  var createSavedJobClicked = function createSavedJobClicked(_ref) {
    var displayType = _ref.displayType;
    var position = _ref.position;

    update(_extends({}, getState(), { saveJobInfo: position + '|' + displayType }));
    dtm.track('job-saved', getState());
  };

  var removeSavedJobClicked = function removeSavedJobClicked(_ref2) {
    var displayType = _ref2.displayType;
    var position = _ref2.position;

    update(_extends({}, getState(), { saveJobInfo: position + '|' + displayType }));
    dtm.track('job-unsaved', getState());
  };

  var learnMoreOpen = function learnMoreOpen() {
    update((0, _link2.default)(getState(), { linkName: 'houston-learn-more-open' }));
    dtm.track('link', getState());
  };

  var learnMoreDismiss = function learnMoreDismiss() {
    update((0, _link2.default)(getState(), { linkName: 'houston-learn-more-dismiss' }));
    dtm.track('link', getState());
  };

  var linkClicked = function linkClicked(props) {
    var linkName = props.linkName;
    var href = props.href;

    var type = (0, _evaluateLinkType2.default)(href, linkName);

    update((0, _link2.default)(getState(), { linkName: linkName }));
    dtm.track(type, getState());
    tealium.link(type);
  };

  var experimentImpression = function experimentImpression(props) {
    dtm.track('experimentImpression', (0, _getExperimentLinkName2.default)(props));
  };

  var campaignClick = function campaignClick(props) {
    update((0, _link2.default)(getState(), props));
    dtm.track('campaign-link', getState());
  };

  var lmisUpdated = function lmisUpdated(_ref3) {
    var _ref3$lmisType = _ref3.lmisType;
    var lmisType = _ref3$lmisType === undefined ? '' : _ref3$lmisType;

    update(_extends({}, getState(), (0, _evaluateLmisEvent2.default)(lmisType)));
  };

  var getScriptTags = function getScriptTags() {
    return [dtm.scriptTag, tealium.scriptTag];
  };

  return {
    getState: getState,
    getScriptTags: getScriptTags,
    searchPerformed: searchPerformed,
    searchResultsPageLoaded: searchResultsPageLoaded,
    moreOptionsClicked: moreOptionsClicked,
    didYouMeanClicked: didYouMeanClicked,
    lastSearchClicked: lastSearchClicked,
    quickSearchClassificationClicked: quickSearchClassificationClicked,
    quickSearchCityClicked: quickSearchCityClicked,
    quickSearchGraduateClicked: quickSearchGraduateClicked,
    jobClassificationClicked: jobClassificationClicked,
    jobSubclassificationClicked: jobSubclassificationClicked,
    jobLocationClicked: jobLocationClicked,
    jobAreaClicked: jobAreaClicked,
    jobSuburbClicked: jobSuburbClicked,
    savedSearchClicked: savedSearchClicked,
    userDetailsUpdated: userDetailsUpdated,
    locationChanged: locationChanged,
    sortModeChanged: sortModeChanged,
    homePageLoaded: homePageLoaded,
    createSaveSearchClicked: createSaveSearchClicked,
    createJobMailClicked: createJobMailClicked,
    createSavedJobClicked: createSavedJobClicked,
    removeSavedJobClicked: removeSavedJobClicked,
    linkClicked: linkClicked,
    learnMoreOpen: learnMoreOpen,
    learnMoreDismiss: learnMoreDismiss,
    experimentImpression: experimentImpression,
    campaignClick: campaignClick,
    lmisUpdated: lmisUpdated,
    whereFieldFocused: whereFieldFocused,
    whereFieldBlanked: whereFieldBlanked,
    whereFieldTyped: whereFieldTyped,
    whereFieldRecentSelected: whereFieldRecentSelected,
    whereFieldSuggestedSelected: whereFieldSuggestedSelected,
    whereFieldAutosuggestedSelected: whereFieldAutosuggestedSelected,
    whereFieldRecentShown: whereFieldRecentShown,
    whereFieldSuggestedShown: whereFieldSuggestedShown
  };
};

exports.createAnalytics = createAnalytics;
exports.hashToUserQueryId = _hashToUserQueryId2.default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-jobs-analytics/build/index.js
 ** module id = 405
 ** module chunks = 0
 **/